module.exports = __webpack_public_path__ + "img/tu06.e28adb54.jpg";